import axios from './http'

export function Channel (token, params) {
  console.log('进行中')
  return axios({
    method: 'post',
    url: '/api/Channel-Flow-Details/Channel',
    headers: {
      'authorization': token
    },
    data: params
  })
}
